export var docElement = document.documentElement;


// WEBPACK FOOTER //
// ./~/tiny-slider/src/helpers/docElement.js